import { render, staticRenderFns } from "./AfterWithErrorConfirmation.vue?vue&type=template&id=208a10bf&scoped=true"
import script from "./AfterWithErrorConfirmation.vue?vue&type=script&lang=js"
export * from "./AfterWithErrorConfirmation.vue?vue&type=script&lang=js"
import style0 from "./AfterWithErrorConfirmation.vue?vue&type=style&index=0&id=208a10bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208a10bf",
  null
  
)

export default component.exports